// GuildCode — entertainment industry guilds. Initial set covers the deals
// the platform sees most; extend in the same shared kernel file as needed.
import { z } from "zod";
export const GuildCodeSchema = z.enum([
    "SAG",
    "DGA",
    "WGA",
    "IATSE",
    "AFM",
    "PGA",
]);
export const GUILD_CODES = GuildCodeSchema.options;
//# sourceMappingURL=GuildCode.js.map